import { useState, useRef, useEffect } from "react";

interface UseMapPlotImportModalProps {
  onClose: () => void;
  reset: () => void;
  openedFromPinSave?: boolean;
}

interface UseMapPlotImportModalReturn {
  tabValue: number;
  setTabValue: React.Dispatch<React.SetStateAction<number>>;
  handleClose: () => void;
  handleTabChange: (_event: React.SyntheticEvent, newValue: number) => void;
  setResetCsvUpload: (resetFn: () => void) => void;
}

/**
 * MapPlotImportModalの状態管理を行うカスタムフック
 */
export const useMapPlotImportModal = ({
  onClose,
  reset,
  openedFromPinSave = false,
}: UseMapPlotImportModalProps): UseMapPlotImportModalReturn => {
  const resetCsvUploadRef = useRef<(() => void) | null>(null);
  const [tabValue, setTabValue] = useState(0);

  // ポップアップの「ピンを保存」から開かれた場合は「一覧を保存」タブにリセット
  useEffect(() => {
    if (openedFromPinSave) {
      setTabValue(0);
    }
  }, [openedFromPinSave]);

  /**
   * CSVアップロードのリセット関数を設定します。
   */
  const setResetCsvUpload = (resetFn: () => void): void => {
    resetCsvUploadRef.current = resetFn;
  };

  /**
   * モーダルを閉じる際のクリーンアップ処理を実行します。
   * フォーム状態、CSVアップロード状態、入力値をすべてリセットします。
   */
  const handleClose = (): void => {
    onClose();
    if (resetCsvUploadRef.current) {
      resetCsvUploadRef.current();
    }
    reset();
  };

  /**
   * タブの切り替えを処理します。
   * @param _event - タブ変更イベント（未使用）
   * @param newValue - 新しいタブのインデックス
   */
  const handleTabChange = (
    _event: React.SyntheticEvent,
    newValue: number
  ): void => {
    setTabValue(newValue);
    reset();
  };

  return {
    tabValue,
    setTabValue,
    handleClose,
    handleTabChange,
    setResetCsvUpload,
  };
};
